export default {
  nav_home: 'Strona główna',
  nav_guide: 'Przewodnik USFans Spreadsheet',
  nav_shopping_guide: 'Przewodnik zakupowy',
  nav_categories: 'Kategorie',
  nav_browse: 'Przeglądaj kategorie',
  lang_label: 'Język',
  footer_tagline: 'Niezależne, uporządkowane centrum zasobów, przewodników i wskazówek bezpieczeństwa USFans Spreadsheet.',
  footer_categories: 'Kategorie',
  footer_resources: 'Zasoby',
  footer_guide: 'Przewodnik USFans Spreadsheet',
  footer_home: 'Strona główna',
  footer_disclaimer: 'To niezależna strona informacyjna i nie jest oficjalną witryną USFans.',
  footer_rights: 'Wszelkie prawa zastrzeżone.',
  footer_visit_main: 'Odwiedź stronę główną',
};